import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { Routes, Route } from "react-router-dom";

import { useAuth } from "../zeon-react-ui/auth/model";
import AppBar from './appbar';
import SetupForm from "./prefs";
import DisMag from "./dismag";
import { Alert } from '@mui/material';

const DashBoard = () => {
  const auth = useAuth();
  if (!auth["appdata"] || !auth["appdata"]["ifs"]) return (
    <Alert severity="error">Your IFS user is not configured. Please contact your IT support.</Alert>
  ); else return (
    <Grid sx={{ m: 0, p: 0 }}>
      <Grid>
        <AppBar />
      </Grid>
      <Grid sx={{p: 1}}>
        <Routes>
          <Route path="/prefs/*" element={<SetupForm />} />
          <Route path="/dismag" element={<DisMag />} />
        </Routes >
      </Grid>
    </Grid>
  )
};

export default DashBoard;